/**
 * Подключение Яндекс Метрики.
 *
 * Рекомендуемый способ:
 * 1. Скопируйте `.env.example` в `.env.production`.
 * 2. Укажите VITE_YANDEX_METRIKA_ID=<ID счётчика>.
 * 3. Соберите приложение командой `npm run build`.
 *
 * Если в кабинете Метрики выдан нестандартный полный код счётчика,
 * его можно вставить в отмеченный блок файла `index.html`.
 */

const counterId = String(import.meta.env.VITE_YANDEX_METRIKA_ID || '').trim()

export function initYandexMetrika() {
  if (!counterId || typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.ym) return

  window.ym = window.ym || function yandexMetrikaQueue(...args) {
    window.ym.a = window.ym.a || []
    window.ym.a.push(args)
  }
  window.ym.l = Date.now()

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://mc.yandex.ru/metrika/tag.js'
  script.dataset.dohodproYandexMetrika = counterId
  document.head.appendChild(script)

  window.ym(Number(counterId), 'init', {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
    defer: true
  })

  const noScript = document.createElement('noscript')
  noScript.innerHTML = `<div><img src="https://mc.yandex.ru/watch/${encodeURIComponent(counterId)}" style="position:absolute;left:-9999px" alt="" /></div>`
  document.body.appendChild(noScript)
}

export function trackYandexPageView(url, title) {
  if (!counterId || typeof window === 'undefined' || typeof window.ym !== 'function') return
  window.ym(Number(counterId), 'hit', url, { title })
}
